import { SRMultiStylesSchema } from './SRMulti.styles';

export const srMultiStyles: SRMultiStylesSchema = {
  headingLabel: {
    color: 'beta.800',
    fontSize: 'md',
    fontWeight: 'normal',
    fontFamily: 'accent',
    mt: '1',
  },
  columnHeadings: {
    color: 'beta.800',
    fontWeight: 'bold',
    fontSize: 'xs',
    minWidth: '12',
    textAlign: 'center',
  },
  headingContainer: {
    mx: '1',
  },
  contentContainer: {
    px: ['2', '0'],
  },
};
